import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';

import { Icon } from './Icon';
import styles from './StatePanel.module.css';

/** Empty / error / offline panel in the catalog empty-state style. */
export function StatePanel({
  icon,
  title,
  children,
  actions,
  requestId,
  headingLevel: Heading = 'h2',
  role,
}: {
  icon: LucideIcon;
  title: string;
  children?: ReactNode;
  actions?: ReactNode;
  requestId?: string;
  headingLevel?: 'h1' | 'h2';
  role?: 'alert' | 'status';
}) {
  return (
    <div className={styles.panel} role={role}>
      <div className={styles.disc}>
        <Icon icon={icon} size={24} />
      </div>
      <Heading className={styles.title}>{title}</Heading>
      {children && <div className={styles.body}>{children}</div>}
      {actions && <div className={styles.actions}>{actions}</div>}
      {requestId && <span className={styles.requestId}>Reference for support: {requestId}</span>}
    </div>
  );
}
